import { useGetSubmissions } from '@app/sdk';
import { SubmissionType } from "../../../../sdk/FakeAccessPayClient";

export function Submissions(props: {
    accountNumber: string
}) {
    let accountNumber = props.accountNumber;
    const { data: submissions, isLoading } = useGetSubmissions({accountNumber});

    return (
        <>
            <h2>Submissions</h2>
            {isLoading && <div className="ui active centered inline loader" />}

            {!isLoading && (!submissions || submissions.length == 0) && <div>No Submissions found</div>}

            {!isLoading && submissions && submissions.length > 0 &&
                <table className="ui compact table" style={{ marginBottom: "20px" }}>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th style={{ width: "90%" }}>Content</th>
                            <th>Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {submissions.map((s: any) => (
                            <tr key={s.id}>
                                <td>{s.id}</td>
                                <td style={{ whiteSpace: "pre-line" }}>{s.content}</td>
                                <td>{SubmissionType[s.submissionType as keyof typeof SubmissionType]}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>}
        </>)
}